import cx from 'classnames';
import React from 'react';
import { Key } from 'w3c-keys';
import { getPixelWidthOfStringUsingCanvas } from '../../../../_utils';
import { ActionMenu, } from '../../../../action-menu';
import { Link } from '../../../../link';
import { Popover } from '../../../../popover';
import styles from './tag-cell.module.scss';
const TAG_COLUMN_EXTRA_SPACE = 55; // considering 55 for margin, padding and border
const MENU_POP_BUTTON_SIZE = 20; // maximum space that will be taken by the +count button to show menu
const DEFAULT_TAG_FONT_STYLE = '14px Optimo-Plain';
export const TagCell = (props) => {
    const { data, context, column } = props;
    const { enableActionMenuOnOverflow } = context;
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const popoverRef = React.useRef(null);
    if (!data.tags || !data.tags.length) {
        return null;
    }
    const onTagClick = (event, tag) => {
        event.preventDefault();
        if (context.onTagClick) {
            context.onTagClick(tag);
        }
    };
    const onEnterOnTag = (event, tag) => {
        event.preventDefault();
        if (event.key === Key.Enter && context.onTagClick) {
            context.onTagClick(tag);
        }
    };
    const computeAllowedLabelCount = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let maxWidth = column.getActualWidth() - TAG_COLUMN_EXTRA_SPACE;
        let currentXPosition = 0;
        let overflowingTags = [];
        const visibleTags = [];
        let maxWidthUpdated = false; // flag to make sure maxWidth is updated only once
        data.tags.some((tag, index) => {
            const textWidth = getPixelWidthOfStringUsingCanvas(tag.name, DEFAULT_TAG_FONT_STYLE);
            let tagWidth = textWidth;
            if (tagWidth > maxWidth) {
                tagWidth = maxWidth;
            }
            const temptXPosition = currentXPosition + tagWidth;
            if (temptXPosition > maxWidth) {
                overflowingTags.push(tag);
                if (!maxWidthUpdated) {
                    maxWidth -= MENU_POP_BUTTON_SIZE;
                    maxWidthUpdated = true;
                }
            }
            else {
                currentXPosition = temptXPosition;
                visibleTags.push(tag);
            }
            if (currentXPosition > maxWidth) {
                // helps in stopping the loop after the available space is consumed
                overflowingTags = [
                    ...overflowingTags,
                    ...data.tags.slice(index + 1),
                ];
                return true;
            }
            return false;
        });
        return [overflowingTags, visibleTags];
    };
    const [overflowingTags, visibleTags] = enableActionMenuOnOverflow
        ? computeAllowedLabelCount()
        : [[], [...data.tags]];
    const getMappedMenuItemGroups = () => {
        const items = overflowingTags === null || overflowingTags === void 0 ? void 0 : overflowingTags.map((tag) => ({
            id: tag.id,
            label: tag.name,
            onClick: (_event) => {
                setIsPopoverOpen(false);
                if (context.onTagClick) {
                    context.onTagClick(tag);
                }
            },
        }));
        return [
            {
                title: '',
                items,
            },
        ];
    };
    const menuItemGroups = enableActionMenuOnOverflow
        ? getMappedMenuItemGroups()
        : [];
    return (React.createElement("div", { className: cx(styles.tagCellContainer, {
            [styles.flexTag]: enableActionMenuOnOverflow,
        }), "data-testid": "tag-list" },
        React.createElement("span", { className: cx(styles.tag, {
                [styles.flexTag]: enableActionMenuOnOverflow,
            }), ref: popoverRef },
            visibleTags.reduce((acc, tag, index) => {
                const tagLink = (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                React.createElement(Link, { key: `taglink-${tag.id}`, color: "black", onClick: (event) => onTagClick(event, tag), onKeyDown: (event) => onEnterOnTag(event, tag), className: cx(styles.tagLink, {
                        [styles.marginLeft]: index > 0,
                        [styles.ellipsisTagLink]: enableActionMenuOnOverflow,
                    }) }, tag.name));
                acc.push(tagLink);
                if (index < visibleTags.length - 1) {
                    acc.push(',');
                }
                return acc;
            }, []),
            enableActionMenuOnOverflow && (overflowingTags === null || overflowingTags === void 0 ? void 0 : overflowingTags.length) > 0 && (React.createElement("span", { className: styles.openMenuButton },
                React.createElement(Link, { color: "blue", onClick: (_event) => setIsPopoverOpen(!isPopoverOpen), className: styles.tagLink },
                    "+",
                    overflowingTags.length)))),
        React.createElement(Popover, { align: "bottom-end", content: React.createElement(ActionMenu, { show: true, menuItemGroups: menuItemGroups }), targetRef: popoverRef, isVisible: enableActionMenuOnOverflow && isPopoverOpen, onClickOutside: () => setIsPopoverOpen(false) })));
};
//# sourceMappingURL=tag-cell.js.map